
const zipRegex =/(^\d{5}$)|(^\d{5}-\d{4}$)/;
export const isValidZipCode =(zipcode)=>zipRegex.test(zipcode);